import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';

export default async function logged({ next, router }) {
  let userToken = await Preferences.get({ key: '_userToken' })
  let sensor = await Preferences.get({ key: '_sensor' })
  const isNative = Capacitor.isNativePlatform();

  await Preferences.set({
    key: "_sensor",
    value: JSON.stringify({
      pass: !isNative,
    })
  });

  if (JSON.parse(userToken.value) && !isNative) {
    return router.push('/home');
  }
  
  if (JSON.parse(userToken.value) && JSON.parse(sensor.value) && !JSON.parse(sensor.value).pass) {
    return router.push('/fingerprint');
  }

  if (JSON.parse(userToken.value) && JSON.parse(sensor.value) && JSON.parse(sensor.value).pass) {
    return router.push('/home');
  }

  return next();
}
